/**
 * ビジネスカテゴリー
 */
export const BusinessCategoryParentCode = {
  TECHNOLOGY: 'technology',
  APPLICATION: 'application',
  ENTERTAINMENT: 'entertainment',
  VEHICLE: 'vehicle',
  SHOPPING: 'shopping',
  BEAUTY: 'beauty',
  FASHION: 'fashion',
  FOOD: 'food',
  LIFESTYLE: 'lifestyle',
  LEARNING: 'learning',
  BUSINESS: 'business',
  MEDICAL: 'medical',
  BUILDING: 'building',
  LEISURE: 'leisure',
  SPORT: 'sport',
  NPO: 'npo',
  INTERNATIONAL: 'international',
  WORK: 'work',
} as const

export const BusinessCategoryParentLabel: { [key: string]: string } = {
  [BusinessCategoryParentCode.TECHNOLOGY]: 'テクノロジー',
  [BusinessCategoryParentCode.APPLICATION]: 'アプリ',
  [BusinessCategoryParentCode.ENTERTAINMENT]: 'エンタメ',
  [BusinessCategoryParentCode.VEHICLE]: '乗り物',
  [BusinessCategoryParentCode.SHOPPING]: 'ショッピング',
  [BusinessCategoryParentCode.BEAUTY]: 'ビューティー',
  [BusinessCategoryParentCode.FASHION]: 'ファッション',
  [BusinessCategoryParentCode.FOOD]: '食',
  [BusinessCategoryParentCode.LIFESTYLE]: 'ライフスタイル',
  [BusinessCategoryParentCode.LEARNING]: '学び',
  [BusinessCategoryParentCode.BUSINESS]: 'ビジネス',
  [BusinessCategoryParentCode.MEDICAL]: '医療',
  [BusinessCategoryParentCode.BUILDING]: '建物',
  [BusinessCategoryParentCode.LEISURE]: 'レジャー',
  [BusinessCategoryParentCode.SPORT]: 'スポーツ・アウトドア',
  [BusinessCategoryParentCode.NPO]: '非営利法人',
  [BusinessCategoryParentCode.INTERNATIONAL]: '国際',
  [BusinessCategoryParentCode.WORK]: 'ワークスタイル',
}

export const BusinessCategoryParentValues = Object.entries(BusinessCategoryParentLabel).map(([code, value]) => ({
  code,
  value,
}))

/**
 * ビジネス子カテゴリー
 */
export const BusinessCategoryChildCode = {
  // テクノロジー
  PC_DEVICE: 'pc_device',
  SMARTPHONE: 'smartphone',
  NETWORK: 'network',
  CAMERA: 'camera',
  HOME_APPLIANCES: 'home_appliances',
  CLOUD_COMPUTING: 'cloud_computing',
  SECURITY: 'security',
  WEB_DEVELOPMENT: 'web_development',
  PRECISION_INSTRUMENTS: 'precision_instruments',
  // アプリ
  ONLINE_SERVICES: 'online_services',
  SMARTPHONE_APP: 'smartphone_app',
  SMARTPHONE_GAME: 'smartphone_game',
  SOLUTIONS: 'solutions',
  // エンタメ
  ENTERTAINMENT_MUSIC: 'entertainment_music',
  MOVIES_PLAYS_DVD: 'movies_plays_dvd',
  PUBLISHING_ART_CULTURE: 'publishing_art_culture',
  GAMES_TOYS: 'games_toys',
  // 乗り物
  AUTOMOTIVE_MOTORCYCLE: 'automotive_motorcycle',
  TRANSPORTATION: 'transportation',
  // ショッピング
  ONLINE_SHOPPING_DELIVERY: 'online_shopping_delivery',
  DEPARTMENT_STORE: 'department_store',
  // ビューティー
  SKINCARE_COSMETICS: 'skincare_cosmetics',
  HEALTH_SUPPLEMENTS: 'health_supplements',
  FITNESS_HEALTHCARE: 'fitness_healthcare',
  // ファッション
  FASHION_WOMEN: 'fashion_women',
  FASHION_MEN: 'fashion_men',
  SHOES_BAGS: 'shoes_bags',
  JEWELRY_ACCESSORIES: 'jewelry_accessories',
  KIDS_BABY_MATERNITY: 'kids_baby_maternity',
  // 食
  FOOD_SWEETS_SNACKS: 'food_sweets_snacks',
  BEVERAGES: 'beverages',
  RESTAURANTS: 'restaurants',
  HOME_DELIVERY: 'home_delivery',
  FAIR_TRADE: 'fair_trade',
  // ライフスタイル
  DIET_HEALTH_SUPPLEMENTS: 'diet_health_supplements',
  INTERIOR_DIY_MISCELLANEOUS: 'interior_diy_miscellaneous',
  PETS_PET_SUPPLIES: 'pets_pet_supplies',
  GIFTS_FLOWERS: 'gifts_flowers',
  ROMANCE_WEDDING: 'romance_wedding',
  CHILDBIRTH_CHILDCARE: 'childbirth_childcare',
  END_OF_LIFE_FUNERAL: 'end_of_life_funeral',
  // 学び
  JOB_HUNTING: 'job_hunting',
  QUALIFICATION_STUDY: 'qualification_study',
  SCHOOL_UNIVERSITY: 'school_university',
  CRAM_SCHOOL: 'cram_school',
  CHILDHOOD_EDUCATION: 'childhood_education',
  // ビジネス
  MANAGEMENT_CONSULTING: 'management_consulting',
  ADVERTISING: 'advertising',
  MARKETING: 'marketing',
  SALES: 'sales',
  FINANCE: 'finance',
  DISTRIBUTION: 'distribution',
  TRANSPORTATION_SHIPPING: 'transportation_shipping',
  MATERIALS_CHEMISTRY: 'materials_chemistry',
  FINANCE_ACCOUNTING: 'finance_accounting',
  LEGAL: 'legal',
  STARTUP: 'startup',
  // 医療
  MEDICAL_HOSPITAL: 'medical_hospital',
  PHARMACEUTICALS: 'pharmaceuticals',
  WELFARE: 'welfare',
  // 建物
  HOUSING_APARTMENTS: 'housing_apartments',
  COMMERCIAL_FACILITIES: 'commercial_facilities',
  ARCHITECTURE_SPACE_DESIGN: 'architecture_space_design',
  CONSTRUCTION: 'construction',
  // レジャー
  HOTELS_INNS: 'hotels_inns',
  TRAVEL_TOURISM: 'travel_tourism',
  AMUSEMENT_PARKS: 'amusement_parks',
  // スポーツ
  BASEBALL: 'baseball',
  SOCCER: 'soccer',
  BASKETBALL: 'basketball',
  VOLLEYBALL: 'volleyball',
  RUGBY: 'rugby',
  TRACK_AND_FIELD: 'track_and_field',
  SWIMMING: 'swimming',
  JUDO: 'judo',
  KENDO: 'kendo',
  MARTIAL_ARTS: 'martial_arts',
  GYMNASTICS: 'gymnastics',
  TABLE_TENNIS: 'table_tennis',
  TENNIS: 'tennis',
  BADMINTON: 'badminton',
  GOLF: 'golf',
  SKIING: 'skiing',
  EXTREME_SPORTS: 'extreme_sports',
  MOUNTAIN_CLIMBING: 'mountain_climbing',
  WALKING: 'walking',
  RUNNING: 'running',
  CYCLING: 'cycling',
  FISHING: 'fishing',
  CAMPING: 'camping',
  CANOEING_SUP: 'canoeing_SUP',
  MARINE_AIR_SPORTS: 'marine_air_sports',
  // NPO
  NONPROFIT_ORGANIZATION: 'nonprofit_organization',
  ASSOCIATION: 'association',
  FOUNDATION: 'foundation',
  // 国際
  ASIA_OCEANIA: 'asia_oceania',
  EUROPE: 'europe',
  NORTH_AMERICA: 'north_america',
  LATIN_AMERICA: 'latin_america',
  AFRICA: 'africa',
  // ワークスタイル
  REMOTE_WORK: 'remote_work',
  WORKATION: 'workation',
  SIDE_JOB: 'side_job',
  VOLUNTEER: 'volunteer',
  AGRICULTURE: 'agriculture',
} as const

export const BusinessCategoryChildLabel: { [key: string]: string } = {
  // テクノロジー
  [BusinessCategoryChildCode.PC_DEVICE]: 'PC・デバイス',
  [BusinessCategoryChildCode.SMARTPHONE]: 'スマートフォン',
  [BusinessCategoryChildCode.NETWORK]: '回線',
  [BusinessCategoryChildCode.CAMERA]: 'カメラ',
  [BusinessCategoryChildCode.HOME_APPLIANCES]: '白物・健康・美容家電',
  [BusinessCategoryChildCode.CLOUD_COMPUTING]: 'クラウドコンピューティング',
  [BusinessCategoryChildCode.SECURITY]: 'セキュリティ',
  [BusinessCategoryChildCode.WEB_DEVELOPMENT]: 'Web・システム開発',
  [BusinessCategoryChildCode.PRECISION_INSTRUMENTS]: '精密機器',
  // アプリ
  [BusinessCategoryChildCode.ONLINE_SERVICES]: 'ネットサービス',
  [BusinessCategoryChildCode.SMARTPHONE_APP]: 'スマートフォンアプリ',
  [BusinessCategoryChildCode.SMARTPHONE_GAME]: 'スマートフォンゲーム',
  [BusinessCategoryChildCode.SOLUTIONS]: 'ソリューション',
  // エンタメ
  [BusinessCategoryChildCode.ENTERTAINMENT_MUSIC]: '芸能・音楽・テレビ・CM',
  [BusinessCategoryChildCode.MOVIES_PLAYS_DVD]: '映画・演劇・DVD',
  [BusinessCategoryChildCode.PUBLISHING_ART_CULTURE]: '出版・アート・カルチャー',
  [BusinessCategoryChildCode.GAMES_TOYS]: 'ゲーム・おもちゃ',
  // 乗り物
  [BusinessCategoryChildCode.AUTOMOTIVE_MOTORCYCLE]: '自動車・バイク',
  [BusinessCategoryChildCode.TRANSPORTATION]: '交通',
  // ショッピング
  [BusinessCategoryChildCode.ONLINE_SHOPPING_DELIVERY]: 'ネットショップ・通販',
  [BusinessCategoryChildCode.DEPARTMENT_STORE]: '百貨店・スーパー・コンビニ・ストア',
  // ビューティー
  [BusinessCategoryChildCode.SKINCARE_COSMETICS]: 'スキンケア・化粧品・ヘア用品',
  [BusinessCategoryChildCode.HEALTH_SUPPLEMENTS]: 'ダイエット・健康食品・サプリメント',
  [BusinessCategoryChildCode.FITNESS_HEALTHCARE]: 'フィットネス',
  // ファッション
  [BusinessCategoryChildCode.FASHION_WOMEN]: 'レディースファッション',
  [BusinessCategoryChildCode.FASHION_MEN]: 'メンズファッション',
  [BusinessCategoryChildCode.SHOES_BAGS]: 'シューズ・バッグ',
  [BusinessCategoryChildCode.JEWELRY_ACCESSORIES]: 'ジュエリー・アクセサリー',
  [BusinessCategoryChildCode.KIDS_BABY_MATERNITY]: 'キッズ・ベビー・マタニティ',
  // 食
  [BusinessCategoryChildCode.FOOD_SWEETS_SNACKS]: 'フード・スイーツ・お菓子',
  [BusinessCategoryChildCode.BEVERAGES]: '飲みもの',
  [BusinessCategoryChildCode.RESTAURANTS]: '飲食店',
  [BusinessCategoryChildCode.HOME_DELIVERY]: '宅配',
  [BusinessCategoryChildCode.FAIR_TRADE]: 'フェアトレード',
  // ライフスタイル
  [BusinessCategoryChildCode.DIET_HEALTH_SUPPLEMENTS]: 'ダイエット・健康食品・サプリメント',
  [BusinessCategoryChildCode.INTERIOR_DIY_MISCELLANEOUS]: 'インテリア・DIY・雑貨',
  [BusinessCategoryChildCode.PETS_PET_SUPPLIES]: 'ペット・ペット用品',
  [BusinessCategoryChildCode.GIFTS_FLOWERS]: 'ギフト・花',
  [BusinessCategoryChildCode.ROMANCE_WEDDING]: '恋愛・ウェディング',
  [BusinessCategoryChildCode.CHILDBIRTH_CHILDCARE]: '出産・育児',
  [BusinessCategoryChildCode.END_OF_LIFE_FUNERAL]: '終活・葬儀',
  // 学び
  [BusinessCategoryChildCode.JOB_HUNTING]: '就職・転職・人材派遣・アルバイト',
  [BusinessCategoryChildCode.QUALIFICATION_STUDY]: '資格・留学・語学',
  [BusinessCategoryChildCode.SCHOOL_UNIVERSITY]: '学校・大学',
  [BusinessCategoryChildCode.CRAM_SCHOOL]: '学習塾・予備校・通信教育',
  [BusinessCategoryChildCode.CHILDHOOD_EDUCATION]: '保育・幼児教育',
  // ビジネス
  [BusinessCategoryChildCode.MANAGEMENT_CONSULTING]: '経営・コンサルティング',
  [BusinessCategoryChildCode.ADVERTISING]: '広告・宣伝・PR',
  [BusinessCategoryChildCode.MARKETING]: 'マーケティング',
  [BusinessCategoryChildCode.SALES]: '営業',
  [BusinessCategoryChildCode.FINANCE]: '金融',
  [BusinessCategoryChildCode.DISTRIBUTION]: '流通',
  [BusinessCategoryChildCode.TRANSPORTATION_SHIPPING]: '運輸・輸送',
  [BusinessCategoryChildCode.MATERIALS_CHEMISTRY]: '素材・化学・エネルギー',
  [BusinessCategoryChildCode.FINANCE_ACCOUNTING]: '財務・経理',
  [BusinessCategoryChildCode.LEGAL]: '法務・特許・知的財産',
  [BusinessCategoryChildCode.STARTUP]: 'スタートアップ',
  // 医療
  [BusinessCategoryChildCode.MEDICAL_HOSPITAL]: '医療・病院',
  [BusinessCategoryChildCode.PHARMACEUTICALS]: '医薬・製薬',
  [BusinessCategoryChildCode.WELFARE]: '福祉・介護・リハビリ',
  // 建物
  [BusinessCategoryChildCode.HOUSING_APARTMENTS]: '住宅・マンション',
  [BusinessCategoryChildCode.COMMERCIAL_FACILITIES]: '商業施設・オフィスビル',
  [BusinessCategoryChildCode.ARCHITECTURE_SPACE_DESIGN]: '建築・空間デザイン',
  [BusinessCategoryChildCode.CONSTRUCTION]: '建設・土木',
  // レジャー
  [BusinessCategoryChildCode.HOTELS_INNS]: 'ホテル・旅館',
  [BusinessCategoryChildCode.TRAVEL_TOURISM]: '旅行・観光',
  [BusinessCategoryChildCode.AMUSEMENT_PARKS]: 'テーマパーク・遊園地',
  // スポーツ
  [BusinessCategoryChildCode.BASEBALL]: '野球',
  [BusinessCategoryChildCode.SOCCER]: 'サッカー',
  [BusinessCategoryChildCode.BASKETBALL]: 'バスケットボール',
  [BusinessCategoryChildCode.VOLLEYBALL]: 'バレーボール',
  [BusinessCategoryChildCode.RUGBY]: 'ラグビー',
  [BusinessCategoryChildCode.TRACK_AND_FIELD]: '陸上競技',
  [BusinessCategoryChildCode.SWIMMING]: '水泳',
  [BusinessCategoryChildCode.JUDO]: '柔道',
  [BusinessCategoryChildCode.KENDO]: '剣道',
  [BusinessCategoryChildCode.MARTIAL_ARTS]: '武道',
  [BusinessCategoryChildCode.GYMNASTICS]: 'ジムニスティクス',
  [BusinessCategoryChildCode.TABLE_TENNIS]: '卓球',
  [BusinessCategoryChildCode.TENNIS]: 'テニス',
  [BusinessCategoryChildCode.BADMINTON]: 'バドミントン',
  [BusinessCategoryChildCode.GOLF]: 'ゴルフ',
  [BusinessCategoryChildCode.SKIING]: 'スキー',
  [BusinessCategoryChildCode.EXTREME_SPORTS]: 'エクストリームスポーツ',
  [BusinessCategoryChildCode.MOUNTAIN_CLIMBING]: 'マウンテンクライミング',
  [BusinessCategoryChildCode.WALKING]: 'ウォーキング',
  [BusinessCategoryChildCode.RUNNING]: 'ランニング',
  [BusinessCategoryChildCode.CYCLING]: 'サイクリング',
  [BusinessCategoryChildCode.FISHING]: '釣り',
  [BusinessCategoryChildCode.CAMPING]: 'キャンピング',
  [BusinessCategoryChildCode.CANOEING_SUP]: 'カヌー',
  [BusinessCategoryChildCode.MARINE_AIR_SPORTS]: 'マリンエアースポーツ',
  // NPO
  [BusinessCategoryChildCode.NONPROFIT_ORGANIZATION]: '非営利法人',
  [BusinessCategoryChildCode.ASSOCIATION]: '協会',
  [BusinessCategoryChildCode.FOUNDATION]: '財団',
  // 国際
  [BusinessCategoryChildCode.ASIA_OCEANIA]: 'アジア・オセアニア',
  [BusinessCategoryChildCode.EUROPE]: 'ヨーロッパ',
  [BusinessCategoryChildCode.NORTH_AMERICA]: '北アメリカ',
  [BusinessCategoryChildCode.LATIN_AMERICA]: 'ラテンアメリカ',
  [BusinessCategoryChildCode.AFRICA]: 'アフリカ',
  // ワークスタイル
  [BusinessCategoryChildCode.REMOTE_WORK]: 'リモートワーク',
  [BusinessCategoryChildCode.WORKATION]: 'ワークアッション',
  [BusinessCategoryChildCode.SIDE_JOB]: 'サイドジョブ',
  [BusinessCategoryChildCode.VOLUNTEER]: 'ボランティア',
  [BusinessCategoryChildCode.AGRICULTURE]: '農業',
}

export const BusinessCategoryChildValues = Object.entries(BusinessCategoryChildLabel).map(([code, value]) => ({
  code,
  value,
}))

// 親カテゴリーと子カテゴリーの関連付け
export const BusinessCategoryCodeRelations: { [key: string]: string[] } = {
  technology: [
    BusinessCategoryChildCode.PC_DEVICE,
    BusinessCategoryChildCode.SMARTPHONE,
    BusinessCategoryChildCode.NETWORK,
    BusinessCategoryChildCode.CAMERA,
    BusinessCategoryChildCode.HOME_APPLIANCES,
    BusinessCategoryChildCode.CLOUD_COMPUTING,
    BusinessCategoryChildCode.SECURITY,
    BusinessCategoryChildCode.WEB_DEVELOPMENT,
    BusinessCategoryChildCode.PRECISION_INSTRUMENTS,
  ],
  application: [
    BusinessCategoryChildCode.ONLINE_SERVICES,
    BusinessCategoryChildCode.SMARTPHONE_APP,
    BusinessCategoryChildCode.SMARTPHONE_GAME,
    BusinessCategoryChildCode.SOLUTIONS,
  ],
  entertainment: [
    BusinessCategoryChildCode.ENTERTAINMENT_MUSIC,
    BusinessCategoryChildCode.MOVIES_PLAYS_DVD,
    BusinessCategoryChildCode.PUBLISHING_ART_CULTURE,
    BusinessCategoryChildCode.GAMES_TOYS,
  ],
  vehicle: [
    BusinessCategoryChildCode.AUTOMOTIVE_MOTORCYCLE,
    BusinessCategoryChildCode.TRANSPORTATION,
  ],
  shopping: [
    BusinessCategoryChildCode.ONLINE_SHOPPING_DELIVERY,
    BusinessCategoryChildCode.DEPARTMENT_STORE,
  ],
  beauty: [
    BusinessCategoryChildCode.SKINCARE_COSMETICS,
    BusinessCategoryChildCode.HEALTH_SUPPLEMENTS,
    BusinessCategoryChildCode.FITNESS_HEALTHCARE,
  ],
  fashion: [
    BusinessCategoryChildCode.FASHION_WOMEN,
    BusinessCategoryChildCode.FASHION_MEN,
    BusinessCategoryChildCode.SHOES_BAGS,
    BusinessCategoryChildCode.JEWELRY_ACCESSORIES,
    BusinessCategoryChildCode.KIDS_BABY_MATERNITY,
  ],
  food: [
    BusinessCategoryChildCode.FOOD_SWEETS_SNACKS,
    BusinessCategoryChildCode.BEVERAGES,
    BusinessCategoryChildCode.RESTAURANTS,
    BusinessCategoryChildCode.HOME_DELIVERY,
    BusinessCategoryChildCode.FAIR_TRADE,
  ],
  lifestyle: [
    BusinessCategoryChildCode.DIET_HEALTH_SUPPLEMENTS,
    BusinessCategoryChildCode.INTERIOR_DIY_MISCELLANEOUS,
    BusinessCategoryChildCode.PETS_PET_SUPPLIES,
    BusinessCategoryChildCode.GIFTS_FLOWERS,
    BusinessCategoryChildCode.ROMANCE_WEDDING,
    BusinessCategoryChildCode.CHILDBIRTH_CHILDCARE,
    BusinessCategoryChildCode.END_OF_LIFE_FUNERAL,
  ],
  learning: [
    BusinessCategoryChildCode.JOB_HUNTING,
    BusinessCategoryChildCode.QUALIFICATION_STUDY,
    BusinessCategoryChildCode.SCHOOL_UNIVERSITY,
    BusinessCategoryChildCode.CRAM_SCHOOL,
    BusinessCategoryChildCode.CHILDHOOD_EDUCATION,
  ],
  business: [
    BusinessCategoryChildCode.MANAGEMENT_CONSULTING,
    BusinessCategoryChildCode.ADVERTISING,
    BusinessCategoryChildCode.MARKETING,
    BusinessCategoryChildCode.SALES,
    BusinessCategoryChildCode.FINANCE,
    BusinessCategoryChildCode.DISTRIBUTION,
    BusinessCategoryChildCode.TRANSPORTATION_SHIPPING,
    BusinessCategoryChildCode.MATERIALS_CHEMISTRY,
    BusinessCategoryChildCode.FINANCE_ACCOUNTING,
    BusinessCategoryChildCode.LEGAL,
    BusinessCategoryChildCode.STARTUP,
  ],
  medical: [
    BusinessCategoryChildCode.MEDICAL_HOSPITAL,
    BusinessCategoryChildCode.PHARMACEUTICALS,
    BusinessCategoryChildCode.WELFARE,
  ],
  building: [
    BusinessCategoryChildCode.HOUSING_APARTMENTS,
    BusinessCategoryChildCode.COMMERCIAL_FACILITIES,
    BusinessCategoryChildCode.ARCHITECTURE_SPACE_DESIGN,
    BusinessCategoryChildCode.CONSTRUCTION,
  ],
  leisure: [
    BusinessCategoryChildCode.HOTELS_INNS,
    BusinessCategoryChildCode.TRAVEL_TOURISM,
    BusinessCategoryChildCode.AMUSEMENT_PARKS,
  ],
  sport: [
    BusinessCategoryChildCode.BASEBALL,
    BusinessCategoryChildCode.SOCCER,
    BusinessCategoryChildCode.BASKETBALL,
    BusinessCategoryChildCode.VOLLEYBALL,
    BusinessCategoryChildCode.RUGBY,
    BusinessCategoryChildCode.TRACK_AND_FIELD,
    BusinessCategoryChildCode.SWIMMING,
    BusinessCategoryChildCode.JUDO,
    BusinessCategoryChildCode.KENDO,
    BusinessCategoryChildCode.MARTIAL_ARTS,
    BusinessCategoryChildCode.GYMNASTICS,
    BusinessCategoryChildCode.TABLE_TENNIS,
    BusinessCategoryChildCode.TENNIS,
    BusinessCategoryChildCode.BADMINTON,
    BusinessCategoryChildCode.GOLF,
    BusinessCategoryChildCode.SKIING,
    BusinessCategoryChildCode.EXTREME_SPORTS,
    BusinessCategoryChildCode.MOUNTAIN_CLIMBING,
    BusinessCategoryChildCode.WALKING,
    BusinessCategoryChildCode.RUNNING,
    BusinessCategoryChildCode.CYCLING,
    BusinessCategoryChildCode.FISHING,
    BusinessCategoryChildCode.CAMPING,
    BusinessCategoryChildCode.CANOEING_SUP,
    BusinessCategoryChildCode.MARINE_AIR_SPORTS,
  ],
  npo: [
    BusinessCategoryChildCode.NONPROFIT_ORGANIZATION,
    BusinessCategoryChildCode.ASSOCIATION,
    BusinessCategoryChildCode.FOUNDATION,
  ],
  international: [
    BusinessCategoryChildCode.ASIA_OCEANIA,
    BusinessCategoryChildCode.EUROPE,
    BusinessCategoryChildCode.NORTH_AMERICA,
    BusinessCategoryChildCode.LATIN_AMERICA,
    BusinessCategoryChildCode.AFRICA,
  ],
  work: [
    BusinessCategoryChildCode.REMOTE_WORK,
    BusinessCategoryChildCode.WORKATION,
    BusinessCategoryChildCode.SIDE_JOB,
    BusinessCategoryChildCode.VOLUNTEER,
    BusinessCategoryChildCode.AGRICULTURE,
  ],
}
